import { api } from './api.js';

$(document).on("click", ".kpi-on-click", function (event) {

    var kpiValue = $(this).data('kpi');

    // Log kpi
    $.ajax({
        url: api.resources.logKPI,
        type: 'POST',
        data: { kpiValue: kpiValue },
        success: function (data) {
        },
        error: function (data) {
        }
    });
});

export const log = {
}